// ABOUTME: role helper functions for checking user permissions with multiple roles
// ABOUTME: provides utilities for role-based access control in the frontend

import { UserRole } from "../services/authSlice";

/**
 * Check if user has a specific role
 */
export const hasRole = (
  userRoles: UserRole[] | undefined,
  requiredRole: UserRole,
): boolean => {
  return userRoles?.includes(requiredRole) || false;
};

/**
 * Check if user has any of the specified roles
 */
export const hasAnyRole = (
  userRoles: UserRole[] | undefined,
  requiredRoles: UserRole[],
): boolean => {
  return requiredRoles.some((role) => userRoles?.includes(role)) || false;
};

/**
 * Check if user has all of the specified roles
 */
export const hasAllRoles = (
  userRoles: UserRole[] | undefined,
  requiredRoles: UserRole[],
): boolean => {
  if (!userRoles || userRoles.length === 0) return false;
  return requiredRoles.every((role) => userRoles.includes(role));
};

/**
 * Legacy helper: Get the primary role from roles array
 * Used for backward compatibility during migration
 */
export const getPrimaryRole = (
  userRoles: UserRole[] | undefined,
): UserRole | undefined => {
  if (!userRoles || userRoles.length === 0) return undefined;

  // prioritize roles in order of privilege
  const priorityOrder: UserRole[] = [
    "developer",
    "tenant-manager",
    "tenant-owner",
    "customer",
  ];

  for (const role of priorityOrder) {
    if (userRoles.includes(role)) {
      return role;
    }
  }

  return userRoles[0];
};
